export default {"src":"/_next/static/media/dlt.e5482387.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};